export default __webpack_public_path__ + "static/sharing-09d6ebc212a86ffb40125caeec7434bc.png";